import React, { useCallback, useEffect, useMemo } from 'react';
import { Doc as YDoc, encodeStateAsUpdate } from 'yjs';
import AssessUserGroup from '../components/AssessUserGroup';
import {
  create as createUserGroupAssessment,
  createFromExisting as createUserGroupAssessmentFromExisting,
  list as listUserGroupAssessments,
} from 'js/actions/user-group-assessment-actions';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { SCHEMAS } from 'js/api/schemas';

import { useQuery } from 'js/hooks/useQuery';

import { initializeFromScratch } from 'js/ydoc/docs/capabilities-assessment';
import { useNotify } from 'js/hooks/useNotify';

function AssessUserGroupContainer({
  createUserGroupAssessment,
  createUserGroupAssessmentFromExisting,
  listUserGroupAssessments,
}) {
  const { workspaceId, userGroupId } = useParams();
  const history = useHistory();

  const refreshRecentQuery = useCallback(
    (queryId) => listUserGroupAssessments(userGroupId, queryId),
    [userGroupId, listUserGroupAssessments]
  );

  const {
    refresh: refreshRecent,
    result: recentAssessments,
    hasLoaded: recentAssessmentsHaveLoaded,
    isLoading: recentAssessmentsIsLoading,
  } = useQuery({
    queryId: `recent-assessments-${userGroupId}`,
    query: refreshRecentQuery,
    schema: SCHEMAS.USER_GROUP_ASSESSMENT_ARRAY,
  });

  // const recentAssessments = [];
  const notify = useNotify();

  const handleCreateFromScratch = useCallback(async () => {
    const doc = new YDoc();
    // initialize a new assessment template

    // const binding = createBinding(doc);

    initializeFromScratch(doc, null, this);

    const initial_update = [...encodeStateAsUpdate(doc).values()];
    // notify({
    //   message: 'Sorry, something went wrong. Please try again.',
    //   type: 'danger',
    // });

    try {
      const result = await createUserGroupAssessment(userGroupId, {
        user_group_id: userGroupId,
        initial_update,
        source: 'new',
      });

      history.push(
        `/w/${workspaceId}/pm/user-groups/${userGroupId}/assessments/${result.id}/customize`
      );
    } catch (_err) {
      // console.error(err);
      notify({
        message: 'Sorry, something went wrong. Please try again.',
        type: 'danger',
      });
    }
  }, [userGroupId, workspaceId, history, createUserGroupAssessment, notify]);

  const handleCreateFromTemplate = async () => {
    console.log('create from template');
  };

  const handleCreateFromRecent = useCallback(
    async (existingAssessmentId) => {
      const result = await createUserGroupAssessmentFromExisting(
        userGroupId,
        existingAssessmentId
      );
      history.push(
        `/w/${workspaceId}/pm/user-groups/${userGroupId}/assessments/${result.id}/customize`
      );
    },
    [userGroupId, createUserGroupAssessmentFromExisting, workspaceId, history]
  );

  useEffect(() => {
    refreshRecent();
  }, [refreshRecent]);

  const filteredRecentAssessments = useMemo(
    () =>
      (recentAssessments ?? [])
        .filter((x) => x.went_live_at)
        .sort((a, b) => b.went_live_at - a.went_live_at)
        .slice(0, 5),
    [recentAssessments]
  );

  return (
    <AssessUserGroup
      onCreateFromScratch={handleCreateFromScratch}
      onCreateFromTemplate={handleCreateFromTemplate}
      onCreateFromRecent={handleCreateFromRecent}
      recentAssessments={filteredRecentAssessments}
      recentAssessmentsHaveLoaded={recentAssessmentsHaveLoaded}
      recentAssessmentsIsLoading={recentAssessmentsIsLoading}
    />
  );
}

export default connect(
  (
    state,
    {
      match: {
        params: { userGroupId },
      },
    }
  ) => {
    return {
      userGroup: state.entities.userGroups[userGroupId],
    };
  },
  {
    createUserGroupAssessment,
    createUserGroupAssessmentFromExisting,
    listUserGroupAssessments,
  }
)(AssessUserGroupContainer);
